import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Account Redux states
import { REGISTER_USER } from './actionTypes';
import { registerUserSuccessful, registerUserFailed } from './actions';

// AUTH related methods - Using real API instead of fake backend
import { registerUser as registerUserAPI } from '../../../helpers/auth_helper'; // Import the real API function
import { getFirebaseBackend } from '../../../helpers/firebase_helper';

// initialize firebase Auth
const fireBaseBackend = getFirebaseBackend();

// Is user register successful then direct plot user in redux.
function* registerUserSaga({ payload: { user, history } }) {
    try {
        console.log('Register saga started with payload:', { user });
        
        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            console.log('Using Firebase authentication for registration');
            const response = yield call(fireBaseBackend.registerUser, user.email, user.password);
            yield put(registerUserSuccessful(response));
        }
        else {
            console.log('Using real API authentication for registration');
            console.log('Calling registerUserAPI with:', user);
            
            // Using real API endpoint
            const response = yield call(registerUserAPI, {
                name: user.name, // Assuming your user object has name field
                email: user.email,
                password: user.password,
                // Add any other required fields based on your API
                ...user
            });
            
            console.log('Register API response:', response);
            
            // // Store user data and token if provided
            // if (response.token) {
            //     localStorage.setItem("authUser", JSON.stringify(response.user));
            //     localStorage.setItem("authToken", response.token);
            //     console.log('User data and token stored in localStorage');
            // } else if (response.user) {
            //     localStorage.setItem("authUser", JSON.stringify(response.user));
            //     console.log('User data stored in localStorage (no token)');
            // }
            
            yield put(registerUserSuccessful(response));
        }
        
        // Navigate to dashboard after successful registration
        if (history && typeof history === 'function') {
            console.log('Navigating to login after registration');
            history('/login');
        }
    } catch (error) {
        console.error('Register saga error:', error);
        console.error('Error details:', {
            message: error.message,
            stack: error.stack,
            response: error.response
        });
        yield put(registerUserFailed(error.message || 'Registration failed'));
    }
}

export function* watchUserRegister() {
    yield takeEvery(REGISTER_USER, registerUserSaga)
}

function* accountSaga() {
    yield all([fork(watchUserRegister)]);
}

export default accountSaga;